import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { DEFAULT_PAGE_INDEX, DEFAULT_PER_PAGE_GET_ALL } from 'src/constants/pagination';
import { ARTICLE_BY_GROUP } from 'src/constants/services';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

export const mostSearchArticleQueryKey = 'mostSearchArticle';

const useMostSearchArticle = () => {
	const { data, ...restAttributes } = useQuery({
		queryKey: [mostSearchArticleQueryKey],
		queryFn: () => {
			return fetchApiV3Publishing({
				url: `${ARTICLE_BY_GROUP.groups}/${ARTICLE_BY_GROUP.model.mostSearch}`,
				payload: {
					page: DEFAULT_PAGE_INDEX,
					per_page: DEFAULT_PER_PAGE_GET_ALL,
				},
			});
		},
		placeholderData: keepPreviousData,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});

	return {
		data: data?.data?.records,
		meta: data?.meta,
		...restAttributes,
	};
};

export default useMostSearchArticle;
